import LoadingSpinner from "ui/atoms/spinner/LoadingSpinner";
import { View } from "ui/atoms/view";
import { Text } from "react-native";
import { Button, ButtonIcon, ButtonText } from "ui/gluestack/button";
import {
  AddIcon,
  ChevronDownIcon,
  ChevronUpIcon,
  TrashIcon,
} from "ui/gluestack/icon";
import {
  Accordion,
  AccordionContent,
  AccordionHeader,
  AccordionIcon,
  AccordionItem,
  AccordionTrigger,
} from "ui/gluestack/accordion";
import { AssessmentEditQuestionsOrganism } from "./AssessmentEditQuestionsOrganism";
import { useAssessmentEdit } from "../context/AssessmentEditContext";
import { SectionHeaderMolecule } from "../molecules/SectionHeaderMolecule";
import clsx from "clsx";
import { SectionPageOrderAtom } from "../atoms/SectionPageOrderAtom";
import { useAssessmentEditPage } from "../context/AssessmentEditPageContext";

interface Props {
  className?: string;
}
export function AssessmentEditSectionsOrganism({ className }: Props) {
  const {
    isFetching,
    error,
    control,
    hasEditingPermission,
    hasPages,
    removePage,
  } = useAssessmentEdit();

  const { sectionsFields, pageIndex, removeSection, appendSection } =
    useAssessmentEditPage();

  if (isFetching) {
    return (
      <View className="flex-1 self-center py-10 bg-white">
        <LoadingSpinner />
      </View>
    );
  }

  if (error) {
    return <View className="bg-white">Error</View>;
  }

  return (
    <View className={clsx("gap-4", className)}>
      <Accordion type="multiple">
        {sectionsFields.map((section, index) => (
          <AccordionItem
            key={section.id ?? `i-${index}`}
            value={`${section.id ?? `i-${index}`}`}
            className="bg-gray-100"
          >
            <AccordionHeader className="p-2 flex-row">
              <View className="flex-row justify-between items-center w-full">
                <SectionPageOrderAtom sectionIndex={index} />

                <SectionHeaderMolecule
                  control={control}
                  index={index}
                  placeholder="Section Name"
                  className="px-2"
                  isDisabled={!hasEditingPermission}
                />
                <AccordionTrigger className="flex-1 justify-end w-auto">
                  {({ isExpanded }) => (
                    <AccordionIcon
                      as={isExpanded ? ChevronUpIcon : ChevronDownIcon}
                    />
                  )}
                </AccordionTrigger>
              </View>
            </AccordionHeader>
            <AccordionContent className="bg-white border rounded-b border-gray-100">
              <AssessmentEditQuestionsOrganism
                removeSection={() => removeSection(index)}
                control={control}
                sectionIndex={index}
              />
            </AccordionContent>
          </AccordionItem>
        ))}

        {hasEditingPermission && sectionsFields.length === 0 ? (
          <View className="flex items-center bg-gray-100 rounded">
            <Text className="text-center text-gray-500 py-4">
              Add a section to get started
            </Text>
          </View>
        ) : null}
      </Accordion>
      {hasEditingPermission ? (
        <View className="flex flex-row justify-between gap-4 py-4">
          <View>
            {hasPages ? (
              <Button
                variant="outline"
                size="sm"
                action="negative"
                onPress={() => removePage(pageIndex)}
              >
                <ButtonIcon as={TrashIcon} />
                <ButtonText>Delete Page</ButtonText>
              </Button>
            ) : null}
          </View>
          <Button variant="outline" size="sm" onPress={() => appendSection()}>
            <ButtonText>Add section</ButtonText>
            <ButtonIcon as={AddIcon} />
          </Button>
        </View>
      ) : null}
    </View>
  );
}
